import React, { useEffect, useState } from 'react';
import { AdminLayout } from '../components/AdminLayout';
import { useApp } from '../context/AppContext';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const AdminPoliciesPage = () => {
  const { getAuthHeaders } = useApp();
  const [policies, setPolicies] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchPolicies();
  }, []);

  const fetchPolicies = async () => {
    try {
      const { data } = await axios.get(`${BACKEND_URL}/api/policies`);
      setPolicies(data);
    } catch (error) {
      toast.error('Failed to fetch policies');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.put(`${BACKEND_URL}/api/policies`, policies, {
        headers: getAuthHeaders(),
      });
      toast.success('Policies updated!');
    } catch (error) {
      toast.error('Failed to update policies');
    } finally {
      setLoading(false);
    }
  };

  if (!policies) return <AdminLayout><div>Loading...</div></AdminLayout>;

  return (
    <AdminLayout>
      <div data-testid="admin-policies-page">
        <h1 className="text-4xl font-serif mb-8">Policies</h1>

        <form onSubmit={handleSubmit} className="glass p-8">
          <Tabs defaultValue="privacy" className="w-full">
            <TabsList className="border-b border-white/10 bg-transparent p-0 h-auto mb-8">
              <TabsTrigger
                value="privacy"
                className="data-[state=active]:border-b-2 data-[state=active]:border-primary rounded-none bg-transparent px-6 py-3"
              >
                Privacy Policy
              </TabsTrigger>
              <TabsTrigger
                value="terms"
                className="data-[state=active]:border-b-2 data-[state=active]:border-primary rounded-none bg-transparent px-6 py-3"
              >
                Terms & Conditions
              </TabsTrigger>
              <TabsTrigger
                value="cancellation"
                className="data-[state=active]:border-b-2 data-[state=active]:border-primary rounded-none bg-transparent px-6 py-3"
              >
                Cancellation Policy
              </TabsTrigger>
            </TabsList>

            <TabsContent value="privacy" className="space-y-4">
              <textarea
                placeholder="Romanian"
                value={policies.privacy_policy.ro}
                onChange={(e) =>
                  setPolicies({ ...policies, privacy_policy: { ...policies.privacy_policy, ro: e.target.value } })
                }
                rows={12}
                className="w-full bg-transparent border border-white/20 p-3 text-sm focus:outline-none focus:border-primary resize-none"
              />
              <textarea
                placeholder="English"
                value={policies.privacy_policy.en}
                onChange={(e) =>
                  setPolicies({ ...policies, privacy_policy: { ...policies.privacy_policy, en: e.target.value } })
                }
                rows={12}
                className="w-full bg-transparent border border-white/20 p-3 text-sm focus:outline-none focus:border-primary resize-none"
              />
              <textarea
                placeholder="French"
                value={policies.privacy_policy.fr}
                onChange={(e) =>
                  setPolicies({ ...policies, privacy_policy: { ...policies.privacy_policy, fr: e.target.value } })
                }
                rows={12}
                className="w-full bg-transparent border border-white/20 p-3 text-sm focus:outline-none focus:border-primary resize-none"
              />
            </TabsContent>

            <TabsContent value="terms" className="space-y-4">
              <textarea
                placeholder="Romanian"
                value={policies.terms_conditions.ro}
                onChange={(e) =>
                  setPolicies({ ...policies, terms_conditions: { ...policies.terms_conditions, ro: e.target.value } })
                }
                rows={12}
                className="w-full bg-transparent border border-white/20 p-3 text-sm focus:outline-none focus:border-primary resize-none"
              />
              <textarea
                placeholder="English"
                value={policies.terms_conditions.en}
                onChange={(e) =>
                  setPolicies({ ...policies, terms_conditions: { ...policies.terms_conditions, en: e.target.value } })
                }
                rows={12}
                className="w-full bg-transparent border border-white/20 p-3 text-sm focus:outline-none focus:border-primary resize-none"
              />
              <textarea
                placeholder="French"
                value={policies.terms_conditions.fr}
                onChange={(e) =>
                  setPolicies({ ...policies, terms_conditions: { ...policies.terms_conditions, fr: e.target.value } })
                }
                rows={12}
                className="w-full bg-transparent border border-white/20 p-3 text-sm focus:outline-none focus:border-primary resize-none"
              />
            </TabsContent>

            <TabsContent value="cancellation" className="space-y-4">
              <textarea
                placeholder="Romanian"
                value={policies.cancellation_policy.ro}
                onChange={(e) =>
                  setPolicies({ ...policies, cancellation_policy: { ...policies.cancellation_policy, ro: e.target.value } })
                }
                rows={12}
                className="w-full bg-transparent border border-white/20 p-3 text-sm focus:outline-none focus:border-primary resize-none"
              />
              <textarea
                placeholder="English"
                value={policies.cancellation_policy.en}
                onChange={(e) =>
                  setPolicies({ ...policies, cancellation_policy: { ...policies.cancellation_policy, en: e.target.value } })
                }
                rows={12}
                className="w-full bg-transparent border border-white/20 p-3 text-sm focus:outline-none focus:border-primary resize-none"
              />
              <textarea
                placeholder="French"
                value={policies.cancellation_policy.fr}
                onChange={(e) =>
                  setPolicies({ ...policies, cancellation_policy: { ...policies.cancellation_policy, fr: e.target.value } })
                }
                rows={12}
                className="w-full bg-transparent border border-white/20 p-3 text-sm focus:outline-none focus:border-primary resize-none"
              />
            </TabsContent>
          </Tabs>

          <Button type="submit" disabled={loading} data-testid="save-policies-button" className="w-full bg-primary text-primary-foreground mt-6">
            {loading ? 'Saving...' : 'Save All Policies'}
          </Button>
        </form>
      </div>
    </AdminLayout>
  );
};

export default AdminPoliciesPage;